import React, { useState, useEffect } from 'react';
import { useAppContext } from '../context/AppContext';
import Overview from './Overview';
import Tutorials from './Tutorials';
import Settings from './Settings';
import Logs from './Logs';
import logo from '../assets/logo.png';
import '../assets/dashboard.css';

const Dashboard = () => {
    const { setToken } = useAppContext();
    const [activeTab, setActiveTab] = useState('dashboard');
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [isNavVisible, setIsNavVisible] = useState(!isMobile);

    const navItems = [
        { id: 'dashboard', label: 'Dashboard' },
        { id: 'activities', label: 'Activities' },
        { id: 'tutorials', label: 'Tutorials' },
        { id: 'settings', label: 'Settings' }
    ];

    useEffect(() => {
        const handleResize = () => {
            const mobile = window.innerWidth <= 768;
            setIsMobile(mobile);
            setIsNavVisible(!mobile);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleLogout = () => {
        setToken(null);
    };

    const toggleNav = () => {
        setIsNavVisible(!isNavVisible);
    };

    const handleNavClick = (tabId) => {
        setActiveTab(tabId);
        if (isMobile) {
            setIsNavVisible(false);
        }
    };

    const renderContent = () => {
        switch (activeTab) {
            case 'dashboard':
                return <Overview />;
            case 'activities':
                return <Logs />;
            case 'tutorials':
                return <Tutorials />;
            case 'settings':
                return <Settings />;
            default:
                return <Overview />;
        }
    };

    return (
        <div className="dashboard-container">
            <nav className={`navbar ${!isNavVisible ? 'mobile-hidden' : ''}`}>
                <div className="navbar-logo">
                    <img src={logo} alt="Slipstream Logo" />
                </div>
                <div className="nav-buttons">
                    {navItems.map((item) => (
                        <button 
                            key={item.id}
                            className={`nav-button ${activeTab === item.id ? 'active' : ''}`}
                            onClick={() => handleNavClick(item.id)}
                        >
                            <h6>{item.label}</h6>
                        </button>
                    ))}
                </div>
                <div className="logout-button">
                    <button 
                        className="nav-button"
                        onClick={handleLogout}
                    >
                        <h6>Logout</h6>
                    </button>
                </div>
            </nav>
            <main className={`main-content ${!isNavVisible ? 'mobile-expanded' : ''}`}>
                {renderContent()}
            </main>
            {isMobile && (
                <button 
                    className="mobile-nav-toggle"
                    onClick={toggleNav}
                >
                ☰
                </button>
            )}
        </div>
    );
}

export default Dashboard;